import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';

import { configs } from '../../../constants/configs/configs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { saveTobaccoChanges } from '../../../actions/individualPortal/dashboard/dashboardActionCreators';
import RadioCell from '../../../components/common/table/RadioCell';
import AlertMessage from '../../../components/individualPortal/dashboard/AlertMsgs/AlertMessage';
import Table from '../../../components/common/table/Table';
import mergeListsById from '../../../utils/miscellaneous/mergeListsById';
import Tooltip from '../../../components/common/tooltip/Tooltip';
import BackToDashboard from '../../../components/common/backToDashboard';

const TobaccoContainer = (props) => {
    const {
        saveTobaccoChanges
    } = props;

    // Uncomment this once we have a fully SPA, without page reloading, so already saved redux data can be reused across all containers.
    // So for now to avoid additional API call, extract from data is saved in localStorage. It should be taken from redux storage instead.
    // const activeTabData = dashboardModels[activeTab];
    // const { enrollments, applicationYear } = activeTabData;

    const applicationYear = localStorage.getItem('applicationYear');
    let initialTobaccoInfo = JSON.parse(localStorage.getItem('tobaccoData'));


    const [editMode, setEditMode] = useState(false);
    const [tobaccoData, setTobaccoData] = useState(initialTobaccoInfo);
    const [tobaccoUsageChanged, setTobaccoUsageChanged] = useState(false);
    const [confirmInfo, setConfirmation] = useState(false);
    const [newPremium, setPremium] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);

    const TOBACCO_TABLE_COLUMN_IDS = {
        NAME: 'name',
        TOBACCO_INDICATOR: 'tobaccoIndicator'
    };

    const columns = [
        { id: TOBACCO_TABLE_COLUMN_IDS.NAME, text: <FormattedMessage id='tobacco_table_name'/>  },
        { id:TOBACCO_TABLE_COLUMN_IDS.TOBACCO_INDICATOR, text: <FormattedMessage id='tobacco_table_indicator'/> }
    ];

    const onChangeHandler = () => {
        setPremium(false);
        setConfirmation(false);
        setEditMode(true);
    };

    const onCancelHandler = () => {
        setTobaccoData(initialTobaccoInfo);
        setConfirmation(false);
        setEditMode(false);
    };

    const onSaveHandler = () => {
        const tobaccoDataFiltered = tobaccoData.map((enrollment) => {
            return {
                id: enrollment.id,
                enrollees: enrollment.enrollees.map(enrollee => ({
                    tobaccoIndicator: enrollee.tobaccoIndicator,
                    applicantGUID: enrollee.guid,
                }))
            };
        });
        const bodyParams = { enrollments: tobaccoDataFiltered };

        saveTobaccoChanges(configs.endpoints.SAVE_TOBACCO, bodyParams).then(res => {
            if (res.status === 'SUCCESS') {
                setErrorMsg(false);

                const enrollmentPremiumData = res.enrollments.reduce((acc, enrollment) => {
                    const { id, netPremium, premiumEffectiveDate } = enrollment;
                    acc.push({ id, netPremium, premiumEffectiveDate });
                    return acc;
                }, []);

                const mergedData = mergeListsById(tobaccoData, enrollmentPremiumData);
                setTobaccoData(mergedData);
                localStorage.setItem('tobaccoData', JSON.stringify(mergedData));
                setPremium(true);

            } else {
                setErrorMsg(true);
                setTobaccoData(initialTobaccoInfo);
                console.error('saveTobaccoChanges', res.errorMessage);
            }
            setEditMode(false);
        });
    };

    const onCertifyCb = () => {
        setConfirmation(!confirmInfo);
    };

    const onRadioValueChangeCb = (value, enrlId, enrolleeId) => {
        setTobaccoUsageChanged(true);
        const updatedTobaccoData = tobaccoData.map(enrollment => {
            if (enrollment.id ===  enrlId) {
                enrollment.enrollees.map(enrollee => {
                    if (enrollee.guid === enrolleeId) {
                        enrollee.tobaccoIndicator = Boolean(value);
                    }
                    return enrollee;

                });
            }
            return enrollment;
        });

        setTobaccoData(updatedTobaccoData);
    };

    const processDataForStaticCell = enrollment => {
        return enrollment.enrollees.map(enrollee => (
            {
                ...enrollee,
                tobaccoIndicator: enrollee.kid ? <Tooltip
                    id='tobacco_table_indicator_kid'
                    content='tobacco_table_indicator_kid_tooltip'
                    index={enrollee.guid}
                /> :
                    enrollee.tobaccoIndicator ? <FormattedMessage id="label.yes"/> : <FormattedMessage id="label.no"/>
            }));
    };

    const processDataForRadioCell = enrollment => (
        enrollment.enrollees.map((enrollee) => {
            const { guid, tobaccoIndicator } = enrollee;
            return { ...enrollee,
                tobaccoIndicator:  enrollee.kid ? <Tooltip
                    id='tobacco_table_indicator_kid'
                    content='tobacco_table_indicator_kid_tooltip'
                    index={`${enrollment.id}_${guid}`}
                /> :
                    <RadioCell
                        legendName='Tobacco Indicator'
                        inputName='tobaccoIndicator'
                        id={`${enrollment.id}_${guid}`}
                        initialValue={tobaccoIndicator}
                        onChangeCb={(value) => { onRadioValueChangeCb(value, enrollment.id, guid); }}
                    />
            };
        })
    );

    return (
        <div id="tobacco" className="usa-layout-docs usa-section gi-main-section tobacco">
            <div className="grid-container gi-grid-container">
                <div className="grid-row grid-gap gi-wrapper">
                    <aside className="usa-layout-docs__sidenav desktop:grid-col-3" id="side-nav">
                        <BackToDashboard/>
                    </aside>
                    <main className="usa-layout-docs__main desktop:grid-col-9" id="main-content">
                        <h3 className="tobacco__header">
                            <FormattedMessage id="tobacco_header" values={{ year: applicationYear }}/>
                        </h3>
                        {
                            errorMsg && <AlertMessage
                                content={<FormattedMessage id="tobacco_failure_update"/>}
                                type="error"
                            />
                        }
                        {
                            tobaccoData.map(enrollment => (
                                <Fragment key={enrollment.id}>
                                    { editMode ?
                                        <AlertMessage
                                            content={<FormattedMessage id="tobacco_enrollment_info"
                                                values={{ planName: <b>{enrollment.plan.planName}</b>,
                                                    amount: enrollment.netPremium ? enrollment.netPremium : enrollment.plan.netPremium,
                                                    secondMsg: <p><FormattedMessage id="tobacco_enrollment_info_second"/></p>
                                                }}/>}
                                            type="info"
                                        /> :
                                        newPremium ? <AlertMessage
                                            content={<FormattedMessage id="tobacco_enrollment_info_changed"
                                                values={{ planName: <b>{enrollment.plan.planName}</b>,
                                                    netPremium: enrollment.netPremium,
                                                    premiumEffectiveDate: enrollment.premiumEffectiveDate
                                                }}/>}
                                            type="info"
                                        /> :
                                            <h4 className="tobacco__plan-name">
                                                <FormattedMessage id="tobacco_table_header_plan_name" values={{ planName: enrollment.plan.planName }}/>
                                            </h4>
                                    }
                                    <Table
                                        data={!editMode ? processDataForStaticCell(enrollment) : processDataForRadioCell(enrollment)}
                                        columns={columns}
                                    />
                                </Fragment>

                            ))
                        }

                        { editMode && tobaccoUsageChanged &&
                        <div className="usa-checkbox">
                            <input className="usa-checkbox__input" id="truth" type="checkbox" name="confirm-tobacco-info" checked={confirmInfo} onChange={onCertifyCb}/>
                            <label className="usa-checkbox__label" htmlFor="truth"><FormattedMessage id="tobacco_table_indicator_checkbox"/></label>
                        </div>
                        }
                        <div className="tobacco__buttons-group">
                            {!editMode ?
                                <button
                                    type="button"
                                    className="usa-button gi-button gi-button__primary"
                                    onClick={onChangeHandler}
                                >
                                    <FontAwesomeIcon icon="edit" className="grid-col-1 icon btn-icon"/>
                                    <FormattedMessage id="tobacco_btn_change"/>
                                </button>
                                :
                                <Fragment>
                                    <button
                                        type="button"
                                        className="usa-button gi-button gi-button__primary"
                                        onClick={onSaveHandler}
                                        disabled={!confirmInfo}
                                    >
                                        <FormattedMessage id="tobacco_btn_save"/>
                                    </button>
                                    <button
                                        type="button"
                                        className="usa-button gi-button gi-button__outline"
                                        onClick={onCancelHandler}
                                    >
                                        <FormattedMessage id="tobacco_btn_cancel"/>
                                    </button>
                                </Fragment>
                            }
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default connect(null, { saveTobaccoChanges })(TobaccoContainer);